<template>
  <div class="vrun-angular-placeholder">{{ component }}</div>
</template>
<script>
import { kebabToCamel } from "../utils.mjs";

import { debug } from "/vodalys/.jslibs";
const log = debug("vue:VrunAngularPlaceholder");

const angularModule = angular.module("vvuejs.vrunAngularPlaceholder", []);

// Get angular references at angular init
let $angularCompile;
let $angularRootScope;

angularModule.run(function ($compile, $rootScope) {
  $angularCompile = $compile;
  $angularRootScope = $rootScope;
});

export default {
  props: {
    component: Object,
    parentScope: Object,
  },
  destroyed() {
console.warn('VueAngularPlaceholder destroyed')
  },
  mounted() {
    // log("mounted", this.parentScope, $angularRootScope);
    let parentScope = this.parentScope || $angularRootScope;
    // log("mounted2", parentScope);

    const _scope = parentScope.$new(true, parentScope);
    // log("mounted3", _scope, this.component);

    _scope.component = this.component;

    this.element = document.createElement(this.component.directive);
    this.element.setAttribute("component", "component");

    // log("element ?", this.element);

    // Passage de paramtre ( :param="myParam" )
    for (let attr in this.$attrs) {
      this.element.setAttribute(attr, kebabToCamel(attr));
      _scope[kebabToCamel(attr)] = this.$attrs[attr];

      this.$watch("$attrs." + kebabToCamel(attr), function (value) {
        _scope[kebabToCamel(attr)] = value;
        setTimeout(() => _scope.$digest());
      });
    }

    // return

    log("compilling ng...", this.element);
    // // debugger;
    this.element = $angularCompile(this.element)(_scope)[0];
    log("compilling ng... DONE");

    // ca se tente :D
    this.$el.replaceWith(this.element);
    this.$el = this.element;

    log("this.$el.replaceWith(this.element);");
  },
};
</script>